import React from 'react';
import BaseModal from './BaseModal';
import { ModalContext } from './ModalContext';
import clsx from 'clsx';

interface ModalRootProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  initialFocusRef?: React.RefObject<HTMLElement>;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  className?: string;
  closeOnOverlayClick?: boolean;
  closeOnEscape?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

const sizeClasses = {
  sm: 'w-full max-w-sm',
  md: 'w-full max-w-md',
  lg: 'w-full max-w-lg',
  xl: 'w-full max-w-xl',
  full: 'w-full max-w-4xl',
};

export function ModalRoot({
  size = 'md',
  className,
  isOpen,
  onClose,
  children,
  initialFocusRef,
  ariaLabel,
  ariaDescribedBy,
  closeOnOverlayClick,
  closeOnEscape,
}: ModalRootProps) {
  const modalClassName = clsx(sizeClasses[size], className);

  return (
    <ModalContext.Provider value={{ onClose, size }}>
      <BaseModal
        isOpen={isOpen}
        onClose={onClose}
        className={modalClassName}
        initialFocusRef={initialFocusRef}
        ariaLabel={ariaLabel}
        ariaDescribedBy={ariaDescribedBy}
        closeOnOverlayClick={closeOnOverlayClick}
        closeOnEscape={closeOnEscape}
      >
        {children}
      </BaseModal>
    </ModalContext.Provider>
  );
}
